import { render, staticRenderFns } from "./SpaceAccordion.vue?vue&type=template&id=b85014aa&scoped=true&"
import script from "./SpaceAccordion.vue?vue&type=script&lang=js&"
export * from "./SpaceAccordion.vue?vue&type=script&lang=js&"
import style0 from "./SpaceAccordion.vue?vue&type=style&index=0&id=b85014aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85014aa",
  null
  
)

export default component.exports